
import Vue from 'vue';
import Btn from '../button/Button.vue';
import Icon from '../icon/Icon.vue';

export default Vue.extend({
    name: 'LikeButton',

    components: {
        Btn,
        Icon
    },

    props: {
        likes: {
            required: true,
            type: Number
        },
        liked: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: () => ''
        }
    },

    computed: {
        classes() {
            return {
                liked: this.liked,
                'read-only': this.readOnly
            };
        },

        cssOverrides() {
            return {
                '--smvp-upvote-color': this.color,
            };
        }
    }
});
